var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckBoxCircle = function SvgCheckBoxCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.62,
    height: 33.041
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.503 15.147v1.377a15 15 0 1 1-8.9-13.707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.506 3.524 15.275 22.059l-4.869-5.555"
  }))));
};
export default SvgCheckBoxCircle;